import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/comandas-restaurantes/MiRestClient.tsx");
